import type { PetChatbot } from '.';

import { action } from '@play-co/replicant';
import { schedulePetChatMessage } from './petChatbot.scheduledActions';
import { defineActions } from '../../utils';
import { getLocalTimezone } from 'src/replicant/utils/time';

export const petChatbotActions = ({ ruleset }: Pick<PetChatbot, 'ruleset'>) =>
  defineActions<unknown>()({
    schedulePetActivity: action((state, __: void, api) => {
      api.chatbot.validateSubscription();
      const now = api.date.now();
      const timeZone = getLocalTimezone(state);
      const chatMessage = ruleset.getNextChatMessageSchedule(
        now,
        api.math.random(),
        timeZone,
      );
      schedulePetChatMessage(chatMessage, now, api);
    }),
  });
